import React, { Component } from 'react';
import {Link} from 'react-router-dom'

class IconBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            iconbox: [
                {
                    id: 1,
                    headding: "+91 7021689253",
                    subheading: "Support 24/7 - Online 24 hours",
                    morelink: "Call us now",
                    icon: 'icon-phone'
                },
                {
                    id: 2,
                    headding: "Mumbai, India",
                    subheading: "Mon- Sat: 09:00 to 18:00",
                    morelink: "Sunday: Close",
                    icon: 'icon-map'
                },
                {
                    id: 3,
                    headding: "contact@asc-construction.com",
                    subheading: "Support 24/7 - Online 24 hours",
                    morelink: "Mail us now",
                    icon:'icon-envelope'
                }
            ]
        }
    }
    
    render() {
        const { companyData } = this.props;
        
        const contactInfo = [
            {
                id: 1,
                headding: companyData?.contact?.phone || "+91 70216 89253",
                subheading: "Support 24/7 - Online 24 hours",
                morelink: "Call us now",
                icon: 'icon-phone'
            },
            {
                id: 2,
                headding: companyData?.contact?.address ? 
                    `${companyData.contact.address.street}, ${companyData.contact.address.city}` : 
                    "Mumbai, India",
                subheading: companyData?.officeTime ? 
                    `Mon-Sat: ${companyData.officeTime.start} to ${companyData.officeTime.end}` : 
                    "Mon- Sat: 09:00 to 18:00",
                morelink: companyData?.officeTime?.timezone || "Sunday: Close",
                icon: 'icon-map'
            },
            {
                id: 3,
                headding: companyData?.contact?.email || "contact@asc-construction.com",
                subheading: "Support 24/7 - Online 24 hours",
                morelink: "Mail us now",
                icon:'icon-envelope'
            }
        ];

        return (
            <div className="row gutter-16">
                {
                    contactInfo.map(data =>(
                        <div className="col-md-4" key={data.id}>
                            <div className="themesflat-spacer clearfix" data-desktop={0} data-mobile={0} data-smobile={35} />
                            <div className="themesflat-icon-box icon-top align-center accent-color style-3 bg-light-snow clearfix">
                                <div className="icon-wrap">
                                    <i className={data.icon} />
                                </div>
                                <div className="text-wrap">
                                <h5 className="heading"><Link to="#">{data.headding}</Link></h5>
                                <p className="sub-heading">{data.subheading}</p>
                                <span className="class more-link"><Link to="#">{data.morelink}</Link></span>
                                </div>
                            </div>
                        </div> 
                    ))
                }                      
            </div>
        );
    }
}

export default IconBox;